import { gql } from '@apollo/client';

export const FETCH_CALMET_CONFIGURATIONS = gql`
    query fetchCalmetConfigurations($filter: GuidIdInFilter) {
        facility {
            models {
                configurations {
                    calmet(filter: $filter) {
                        __typename
                        id
                        name
                        description
                        timeStep
                        windUnitId
                        sourceForTypes
                        isForecast
                        overrideTimeZoneId
                        settings
                        grid
                        ... on CalmetWithProcessDataConfiguration {
                            maxLatencySeconds
                            maxGapFillSeconds
                            surfaceWeatherStationIds
                            upperAirWeatherStationIds
                        }
                    }
                }
            }
        }
    }
`;
